(function () {
  class FancyGroupRule extends SlotsEngine.instantiators.SymbolRule {
    constructor() {
      super();
    }

    initialise(json) {
      let groupings = {};
      for (let i = 0; i < json.rules.length; ++i) {
        groupings = Object.assign(groupings, json.rules[i]);
      }
      this._weightings = [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1000, 100,
      ];
      this._totalWeightings = this._weightings.reduce(function (
        accumulator,
        currentValue
      ) {
        return accumulator + currentValue;
      });
      super.initialise(groupings);
    }

    isSymbolValid(symbolId, previousWindowSymbols, nextSymbol) {
      if (symbolId === previousWindowSymbols[previousWindowSymbols.length - 1])
        // cant continue the group from previous group
        return false;
      else if (symbolId === nextSymbol) return false;
      else if (!this.doesSymbolHaveRule(symbolId))
        // if there is no rule then it is fine
        return true;

      return true;
    }

    // used for unit tests, not used in client dev
    testReelBandPassesRule(reelBand) {
      for (let prop in this._rules) {
        if (this._rules.hasOwnProperty(prop)) {
          let symId = Number(prop);
          let count = this._rules[prop].count;
          for (let i = 0; i < reelBand.length; ++i) {
            if (reelBand[i] === symId) {
              let brokenRule = false;
              let matching = 1;
              for (let j = 1; j < count; ++j) {
                if (reelBand[(i + j) % reelBand.length] !== symId) {
                  brokenRule = true;
                  break;
                }
                ++matching;
              }
              if (reelBand[(i + count) % reelBand.length] === symId)
                brokenRule = true;

              if (brokenRule) {
                if (i === 0) {
                  // lets not stop just yet, it might wrap around completing the rule
                  let symbolsMissing = count - matching;
                  reelBand = reelBand
                    .slice(reelBand.length - symbolsMissing, reelBand.length)
                    .concat(reelBand);
                  reelBand.splice(
                    reelBand.length - symbolsMissing,
                    symbolsMissing
                  );
                  i = -1;
                } else {
                  return false;
                }
              } else {
                i += count - 1;
              }
            }
          }
        }
      }
      return true;
    }

    getNumSymbolsToReserve(symbolId) {
      if (!this.doesSymbolHaveRule(symbolId)) return 0;

      if (this._rules["" + symbolId].count === 4) {
        return this.getNumOfSymbolsBasedOnAppetureHeight();
      }
      return this._rules["" + symbolId].count;
    }

    getNumOfSymbolsBasedOnAppetureHeight() {
      const reelVisual = resourceManager.get(
        "slotContainer:reelContainer:reel" + this.Props.reelId
      );
      const reelHeight =
        (this.Props.reelId === 0) | (this.Props.reelId === 4)
          ? 3
          : reelVisual.getReelSpinnerData().getTotalAppertureSize();
      let weights = [50, 30, 10, 5, 5]; //Probably should've used a dict / map for this.
      switch (reelHeight) {
        case 3:
          weights = [50, 30, 10, 5, 5];
          break;
        case 4:
          weights = [40, 30, 15, 10, 5];
          break;
        case 5:
          weights = [35, 30, 25, 10, 10];
          break;
        case 6:
          weights = [30, 20, 20, 15, 15];
          break;
        case 7:
          weights = [20, 20, 20, 20, 20];
          break;
      }
      const cumulativeWeights = [];
      for (let i = 0; i < weights.length; i += 1) {
        cumulativeWeights[i] = weights[i] + (cumulativeWeights[i - 1] || 0);
      }
      const maxCumulativeWeight =
        cumulativeWeights[cumulativeWeights.length - 1];
      const randomNum = maxCumulativeWeight * Math.random();
      for (let i = 0; i < weights.length; i++) {
        if (cumulativeWeights[i] >= randomNum) {
          return i + 3;
        }
      }
    }

    getReservedSymbols(symbol, num) {
      if (this._rules["" + symbol] === undefined) {
        return [];
      }
      const validSymbols = this._rules["" + symbol].validSymbols;

      let symbols = [];
      for (let i = 0; i < num; ++i) {
        const weightValue = Math.floor(Math.random() * this._totalWeightings);

        if (weightValue > 100) {
          const newSymbol = validSymbols[0];
          symbols.push(newSymbol);
        } else {
          const newSymbol = validSymbols[1];
          symbols.push(newSymbol);
        }
      }

      //  for (let i = 0; i < num; ++i) {
      //    const weightValue = Math.floor(Math.random() * this._totalWeightings);
      //    let count = 0;
      //    for (
      //      let weightIndex = 0;
      //      weightIndex < this._weightings.length;
      //      ++weightIndex
      //    ) {
      //      count += this._weightings[weightIndex];
      //      if (weightValue < count) {
      //        const newSymbol =
      //          validSymbols[Math.floor(Math.random() * validSymbols.length)];
      //        symbols.push(newSymbol);
      //        break;
      //      }
      //    }
      //  }
      return symbols;
    }

    getAdditionalSymbolsNeededToSatisfyRule(symbolsInView) {
      let res = [];
      let lastSymbol = symbolsInView[symbolsInView.length - 1];

      let count = 0;
      for (let i = symbolsInView.length - 1; i >= 0; --i) {
        if (this.doesSymbolHaveRule(symbolsInView[i])) {
          ++count;
        } else {
          break;
        }
      }
      if (count > 0) {
        let numExtraNeeded = Math.max(
          this.getNumSymbolsNeeded(lastSymbol) - count,
          0
        );
        res = this.getReservedSymbols(lastSymbol, numExtraNeeded);
      }

      return res;
    }
  }
  resourceManager.registerController("SymbolRules_fancygroup", function () {
    return new FancyGroupRule();
  });
})();
